// axios
import axios from 'axios'
import store from '@/store/store'
const domain = ''
const token = store.state.token
// const headers = {
//   Authorization: store.state.token,
// }
const service = axios.create({
  domain,
  // You can add your headers here
  headers: {
    Authorization: token,
  },
})

service.interceptors.request.use(
  function (config) {
    // config.headers.TT-Admin-Token = localStorage.getItem("token");
    // config.headers.common[]
    // 在发送请求之前做些什么
    // console.log(config);
    console.log('token', token)
    config.headers['Authorization'] = store.state.token
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

export default service
